{
  "about.blocks": "Servidores moderados",
  "about.contact": "Contato:",
  "about.default_locale": "Padrão",
  "about.disclaimer": "Mastodon é um software livre, de código aberto e uma marca registrada do Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "Razão não disponível",
  "about.domain_blocks.preamble": "O \"Mastodon\" geralmente permite que você veja o conteúdo e interaja com usuários de qualquer outro servidor no \"fediverso\". Estas são as exceções deste servidor em específico.",
  "about.domain_blocks.silenced.explanation": "Você geralmente não verá perfis e conteúdo deste servidor, a menos que você o procure explicitamente ou opte por seguir.",
  "about.domain_blocks.silenced.title": "Limitado",
  "about.domain_blocks.suspended.explanation": "Nenhum dado desse servidor será processado, armazenado ou trocado, impossibilitando qualquer interação ou comunicação com os usuários deste servidor.",
  "about.domain_blocks.suspended.title": "Suspenso",
  "about.language_label": "Idioma",
  "about.not_available": "Esta informação não foi disponibilizada neste servidor.",
  "about.powered_by": "Rede social descentralizada baseada no {mastodon}",
  "about.rules": "Regras do servidor",
  "account.account_note_header": "Nota pessoal",
  "account.activity": "Atividade",
  "account.add_note": "Adicionar nota pessoal",
  "account.add_or_remove_from_list": "Adicionar ou remover de listas",
  "account.badges.admin": "Admin",
  "account.badges.blocked": "Bloqueado",
  "account.badges.bot": "Robô",
  "account.badges.domain_blocked": "Domínio bloqueado",
  "account.badges.group": "Grupo",
  "account.badges.muted": "Silenciado",
  "account.badges.muted_until": "Silenciado até {until}",
  "account.block": "Bloquear @{name}",
  "account.block_domain": "Bloquear domínio {domain}",
  "account.block_short": "Bloquear",
  "account.blocked": "Bloqueado",
  "account.cancel_follow_request": "Cancelar solicitação para seguir",
  "account.copy": "Copiar link do perfil",
  "account.direct": "Mencione em privado @{name}",
  "account.disable_notifications": "Cancelar notificações de @{name}",
  "account.edit_note": "Editar nota pessoal",
  "account.edit_profile": "Editar perfil",
  "account.edit_profile_short": "Editar",
  "account.enable_notifications": "Notificar quando @{name} publicar",
  "account.endorse": "Recomendar",
  "account.familiar_followers_many": "Seguido por {name1}, {name2}, e {othersCount, plural, one {um outro que você conhece} other {# outros que você conhece}}",
  "account.familiar_followers_one": "Seguido por {name1}",
  "account.familiar_followers_two": "Seguido por {name1} e {name2}",
  "account.featured": "Em destaque",
  "account.featured.accounts": "Perfis",
  "account.featured.collections": "Coleções",
  "account.featured.new_collection": "Nova coleção",
  "account.field_overflow": "Exibir conteúdo completo",
  "account.filters.all": "Toda atividade",
  "account.filters.boosts_toggle": "Exibir impulsos",
  "account.filters.posts_boosts": "Publicações e impulsos",
  "account.filters.posts_only": "Publicações",
  "account.filters.posts_replies": "Publicações e respostas",
  "account.filters.replies_toggle": "Exibir respostas",
  "account.follow": "Seguir",
  "account.follow_back": "Seguir de volta",
  "account.follow_back_short": "Seguir de volta",
  "account.follow_request": "Pedir para seguir",
  "account.follow_request_cancel": "Cancelar solicitação",
  "account.follow_request_cancel_short": "Cancelar",
  "account.follow_request_short": "Solicitar",
  "account.followers": "Seguidores",
  "account.followers.empty": "Nada aqui.",
  "account.followers_counter": "{count, plural, one {{counter} seguidor} other {{counter} seguidores}}",
  "account.followers_you_know_counter": "{counter} que você conhece",
  "account.following": "Seguindo",
  "account.following_counter": "{count, plural, one {{counter} seguindo} other {{counter} seguindo}}",
  "account.follows.empty": "Nada aqui.",
  "account.follows_you": "Segue você",
  "account.go_to_profile": "Ir ao perfil",
  "account.hame.invalid_handle": "Nome de usuário indisponível",
  "account.hide_reblogs": "Ocultar impulsos de @{name}",
  "account.in_memoriam": "In Memoriam.",
  "account.join_modal.day": "Dia",
  "account.join_modal.me": "Você está em {server} desde",
  "account.join_modal.me_anniversary": "Feliz Fediversário! Você está em {server} desde",
  "account.join_modal.me_today": "É seu primeiro dia em {server}!",
  "account.join_modal.other": "{name} está em {server} desde",
  "account.join_modal.other_today": "Este é o primeiro dia de {name} em {server}!",
  "account.join_modal.share.celebrate": "Compartilhar publicação comemorativa",
  "account.join_modal.share.intro": "Compartilhar publicação de apresentação",
  "account.join_modal.share.welcome": "Compartilhar publicação de boas-vindas",
  "account.join_modal.years": "{number, plural, one {ano} other {anos}}",
  "account.joined_short": "Entrou",
  "account.languages": "Alterar idiomas inscritos",
  "account.last_active": "Última atividade",
  "account.link_verified_on": "A propriedade deste link foi verificada em {date}",
  "account.locked_info": "Trancado. Seguir requer aprovação manual do perfil.",
  "account.media": "Mídia",
  "account.mention": "Mencionar @{name}",
  "account.menu.add_to_collection": "Adicionar à coleção…",
  "account.menu.add_to_list": "Adicionar à lista…",
  "account.menu.block": "Bloquear conta",
  "account.menu.block_domain": "Bloquear {domain}",
  "account.menu.copied": "Link da conta copiado para área de transferência",
  "account.menu.copy": "Copiar link",
  "account.menu.direct": "Mencionar em privado",
  "account.menu.hide_reblogs": "Ocultar impulsos na timeline",
  "account.menu.mention": "Mencionar",
  "account.menu.mute": "Silenciar conta",
  "account.menu.note.description": "Visível somente para você",
  "account.menu.open_original_page": "Ver em {domain}",
  "account.menu.open_original_page_no_domain": "Visualizar no servidor original",
  "account.menu.remove_follower": "Remover seguidor",
  "account.menu.report": "Denunciar conta",
  "account.menu.share": "Compartilhar…",
  "account.menu.show_reblogs": "Exibir impulsos na timeline",
  "account.menu.unblock": "Desbloquear conta",
  "account.menu.unblock_domain": "Desbloquear {domain}",
  "account.menu.unmute": "Dessilenciar conta",
  "account.moved_to": "{name} indicou que sua nova conta agora é:",
  "account.mute": "Silenciar @{name}",
  "account.mute_notifications_short": "Silenciar notificações",
  "account.mute_short": "Silenciar",
  "account.muted": "Silenciado",
  "account.mutual": "Vocês se seguem",
  "account.name.copy": "Copiar nome de usuário",
  "account.name.help.domain": "{domain} é o servidor que hospeda o perfil e publicações do usuário.",
  "account.name.help.domain_self": "{domain} é o seu servidor, que hospeda seu perfil e publicações.",
  "account.name.help.footer": "Assim como pode enviar e-mails para pessoas usando diferentes provedores de e-mail, você pode interagir com pessoas em outros servidor do Mastodon, e com qualquer um em outros apps da Fediverse.",
  "account.name.help.header": "Um nome de usuário é como um endereço de email",
  "account.name.help.invalid_explanation": "Isso pode ocorrer quando um usuário altera seu nome, e geralmente é temporário. Caso persistir, pode ser devido a um servidor indisponível ou uma má configuração da conta deles.",
  "account.name.help.invalid_header": "O nome deste usuário está sendo atualizado",
  "account.name.help.username": "{username} é o nome de usuário desta conta no servidor dela. Alguém em outro servidor pode ter o mesmo nome de usuário.",
  "account.name.help.username_self": "{username} é seu nome de usuário neste servidor. Alguém em outro servidor pode ter o mesmo nome de usuário.",
  "account.name_info": "O que isso quer dizer?",
  "account.no_bio": "Nenhuma descrição fornecida.",
  "account.node_modal.callout": "Notas pessoais são visíveis apenas para você.",
  "account.node_modal.edit_title": "Editar nota pessoal",
  "account.node_modal.error_unknown": "Não foi possível salvar a nota",
  "account.node_modal.field_label": "Nota Pessoal",
  "account.node_modal.save": "Salvar",
  "account.node_modal.title": "Adicionar nota pessoal",
  "account.note.edit_button": "Editar",
  "account.note.title": "Nota pessoal (visível apenas para você)",
  "account.open_original_page": "Abrir a página original",
  "account.pending": "Pendente",
  "account.posts": "Publicações",
  "account.remove_from_followers": "Remover {name} dos seguidores",
  "account.report": "Denunciar @{name}",
  "account.requested_follow": "{name} quer te seguir",
  "account.share": "Compartilhar perfil de @{name}",
  "account.show_reblogs": "Mostrar impulsos de @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} publicação} other {{counter} publicações}}",
  "account.timeline.pinned": "Fixado",
  "account.timeline.pinned.view_all": "Ver todas as publicações fixadas",
  "account.unblock": "Desbloquear @{name}",
  "account.unblock_domain": "Desbloquear domínio {domain}",
  "account.unblock_domain_short": "Desbloquear",
  "account.unblock_short": "Desbloquear",
  "account.unendorse": "Remover",
  "account.unfollow": "Deixar de seguir",
  "account.unmute": "Dessilenciar @{name}",
  "account.unmute_notifications_short": "Ativar som de notificações",
  "account.unmute_short": "Desativar silêncio",
  "account_edit.advanced_settings.bot_hint": "Alertar a outros que a conta realiza ações automáticas que talvez não sejam monitoradas",
  "account_edit.advanced_settings.bot_label": "Conta automatizada",
  "account_edit.advanced_settings.title": "Configurações avançadas",
  "account_edit.bio.add_label": "Adicionar biografia",
  "account_edit.bio.edit_label": "Editar biografia",
  "account_edit.bio.placeholder": "Insira uma breve apresentação para ajudar os outros a lhe identificarem.",
  "account_edit.bio.title": "Biografia",
  "account_edit.bio_modal.add_title": "Adicionar biografia",
  "account_edit.bio_modal.edit_title": "Editar biografia",
  "account_edit.column_button": "Feito",
  "account_edit.column_title": "Editar perfil",
  "account_edit.custom_fields.add_label": "Acrescentar campo",
  "account_edit.custom_fields.edit_label": "Editar campo",
  "account_edit.custom_fields.placeholder": "Insira seus pronomes, links externos ou qualquer coisa que queira compartilhar.",
  "account_edit.custom_fields.reorder_button": "Reordenar campos",
  "account_edit.custom_fields.tip_content": "Você pode facilmente dar credibilidade à sua conta Mastodon verificando os links para os seus sites.",
  "account_edit.custom_fields.tip_title": "Dica: Adicionar links verificados",
  "account_edit.custom_fields.title": "Campos personalizados",
  "account_edit.custom_fields.verified_hint": "Como adiciono um link verificado?",
  "account_edit.display_name.add_label": "Acrescentar nome de exibição",
  "account_edit.display_name.edit_label": "Editar nome de exibição",
  "account_edit.display_name.placeholder": "Seu nome de exibição é a forma com que seu nome aparece em seu perfil e em suas linhas do tempo.",
  "account_edit.display_name.title": "Nome de exibição",
  "account_edit.featured_hashtags.edit_label": "Acrescentar hashtags",
  "account_edit.featured_hashtags.placeholder": "Ajude outros a identificar e ter acesso rápido a seus tópicos favoritos.",
  "account_edit.featured_hashtags.title": "Hashtags em destaque",
  "account_edit.field_actions.delete": "Remover campo",
  "account_edit.field_actions.edit": "Editar campo",
  "account_edit.field_delete_modal.confirm": "Tem certeza que deseja excluir este campo personalizado? Esta ação não pode ser desfeita.",
  "account_edit.field_delete_modal.delete_button": "Excluir",
  "account_edit.field_delete_modal.title": "Excluir campo personalizado?",
  "account_edit.field_edit_modal.add_title": "Adicionar campo personalizado",
  "account_edit.field_edit_modal.discard_confirm": "Descartar",
  "account_edit.field_edit_modal.discard_message": "Você possui alterações não salvas. Tem certeza de que deseja descartá-las?",
  "account_edit.field_edit_modal.edit_title": "Editar campo personalizado",
  "account_edit.field_edit_modal.length_warning": "Limite recomendado de caracteres excedido. Usuários em telefones podem não conseguir ver o campo completo.",
  "account_edit.field_edit_modal.link_emoji_warning": "Recomendamos não utilizar emojis personalizados combinados com URLs. Campos personalizados contendo ambos serão exibidos apenas como texto em vez de link, para evitar confusão dos usuários.",
  "account_edit.field_edit_modal.name_hint": "Ex. \"Site pessoal\"",
  "account_edit.field_edit_modal.name_label": "Descrição",
  "account_edit.field_edit_modal.url_warning": "Para adicionar um link, inclua {protocol} no início.",
  "account_edit.field_edit_modal.value_hint": "Ex.: \"https://example.me\"",
  "account_edit.field_edit_modal.value_label": "Valor",
  "account_edit.field_reorder_modal.drag_cancel": "Arraste cancelado. O campo \"{item}\" foi solto.",
  "account_edit.field_reorder_modal.drag_end": "O campo \"{item}\" foi solto.",
  "account_edit.field_reorder_modal.drag_instructions": "Para reordenar campos personalizados, pressione espaço ou enter. Enquanto arrasta, utilize as teclas de seta para mover o campo para cima ou para baixo. Pressione espaço ou enter novamente para colocar o campo em sua nova posição, ou pressione 'Esc' para cancelar.",
  "account_edit.field_reorder_modal.drag_move": "Campo \"{item}\" foi movido.",
  "account_edit.field_reorder_modal.drag_over": "Campo \"{item}\" foi movido para \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Campo \"{item}\" foi pego.",
  "account_edit.field_reorder_modal.handle_label": "Arrastar campo \"{item}\"",
  "account_edit.field_reorder_modal.title": "Reordenar campos",
  "account_edit.image_alt_modal.add_title": "Acrescentar texto alternativo",
  "account_edit.image_alt_modal.details_content": "FAÇA: <ul><li> Descreva-se como retratado/a</li><li>Utilize linguagem em terceira pessoa (p. ex.: \"Alex\" em vez de \"eu\")</li><li>Seja sucinto/a — algumas palavras costumam ser o suficiente</li></ul> NÃO FAÇA: <ul><li>Comece com \"Foto de\" — é redundante para leitores de tela</li></ul> EXEMPLO:<ul><li>\"Alex vestindo uma camisa verde e óvulos\"</li></ul>",
  "account_edit.image_alt_modal.details_title": "Dicas: Texto alternativo para fotos",
  "account_edit.image_alt_modal.edit_title": "Editar texto alternativo",
  "account_edit.image_alt_modal.text_hint": "Texto alternativo ajuda susuários de leitores de tela a entender seu conteúdo.",
  "account_edit.image_alt_modal.text_label": "Texto alternativo",
  "account_edit.image_delete_modal.confirm": "Tem certeza de que deseja excluir esta imagem? Esta ação não pode ser desfeita.",
  "account_edit.image_delete_modal.delete_button": "Excluir",
  "account_edit.image_delete_modal.title": "Excluir imagem?",
  "account_edit.image_edit.add_button": "Inserir imagem",
  "account_edit.image_edit.alt_add_button": "Inserir texto alternativo",
  "account_edit.image_edit.alt_edit_button": "Editar texto alternativo",
  "account_edit.image_edit.remove_button": "Remover imagem",
  "account_edit.image_edit.replace_button": "Substituir imagem",
  "account_edit.item_list.delete": "Excluir {name}",
  "account_edit.item_list.edit": "Editar {name}",
  "account_edit.name_modal.add_title": "Inserir nome de exibição",
  "account_edit.name_modal.edit_title": "Editar nome de exibição",
  "account_edit.profile_tab.button_label": "Personalizar",
  "account_edit.profile_tab.hint.description": "Essas configurações definem o que os usuários veem no {server} através dos aplicativos oficiais, mas podem não se aplicar a usuários em servidores e aplicativos de terceiros.",
  "account_edit.profile_tab.hint.title": "A exibição pode variar",
  "account_edit.profile_tab.show_featured.description": "'Em Destaque' é uma aba opcional onde você pode exibir outras contas.",
  "account_edit.profile_tab.show_featured.title": "Exibir aba 'Em destaque'",
  "account_edit.profile_tab.show_media.description": "'Mídia' é uma aba opcional que mostra suas publicações contendo imagens ou vídeos.",
  "account_edit.profile_tab.show_media.title": "Exibir aba 'Mídia'",
  "account_edit.profile_tab.show_media_replies.description": "Se ativa, a aba Mídia mostrará ambas suas publicações e respostas a outras pessoas.",
  "account_edit.profile_tab.show_media_replies.title": "Incluir respostas na aba 'Mídia'",
  "account_edit.profile_tab.show_relations.description": "Exibe em seu perfil as contas que segue e seguidores para outros usuários. As pessoas poderão ainda ver se você as segue.",
  "account_edit.profile_tab.show_relations.title": "Exibir 'Seguidores' e 'Seguindo'",
  "account_edit.profile_tab.subtitle": "Personalize como seu perfil é exibido.",
  "account_edit.profile_tab.title": "Configurações de exibição do perfil",
  "account_edit.save": "Salvar",
  "account_edit.upload_modal.back": "Voltar",
  "account_edit.upload_modal.done": "Concluído",
  "account_edit.upload_modal.next": "Próximo",
  "account_edit.upload_modal.step_crop.zoom": "Ampliar",
  "account_edit.upload_modal.step_upload.button": "Buscar arquivos",
  "account_edit.upload_modal.step_upload.dragging": "Solte para enviar",
  "account_edit.upload_modal.step_upload.header": "Escolha uma imagem",
  "account_edit.upload_modal.step_upload.hint": "Formato .webp, .png, .gif ou .jpg, até {limit}MB.{br}A imagem será redimensionada para {width}x{height}px.",
  "account_edit.upload_modal.title_add.avatar": "Adicionar foto de perfil",
  "account_edit.upload_modal.title_add.header": "Adicionar foto de capa",
  "account_edit.upload_modal.title_replace.avatar": "Substituir foto de perfil",
  "account_edit.upload_modal.title_replace.header": "Substituir foto de capa",
  "account_edit.verified_modal.details": "Dê credibilidade ao seu perfil do Mastodon, verificando links para sites pessoais. Veja como funciona:",
  "account_edit.verified_modal.invisible_link.details": "Adicione o link ao cabeçalho. A parte importante é rel=\"me\" que impede personificação em sites com conteúdo gerado por usuários. Você pode usar um rótulo de link no cabeçalho em vez de {tag}, porém o HTML deverá ser acessível sem precisar de JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "Como tornar o link invisível?",
  "account_edit.verified_modal.step1.header": "Copie o código HTML abaixo e cole no cabeçalho do seu site",
  "account_edit.verified_modal.step2.details": "Se já adicionou seu site como um campo personalizado, deverá excluí-lo e adicioná-lo novamente para acionar a verificação.",
  "account_edit.verified_modal.step2.header": "Adicione seu site como um campo personalizado",
  "account_edit.verified_modal.title": "Como adicionar um link verificado",
  "account_edit_tags.add_tag": "Adicionar #{tagName}",
  "account_edit_tags.column_title": "Editar rótulos",
  "account_edit_tags.help_text": "Hashtags em destaque ajudam os usuários a descobrir e interagir com seu perfil. Elas aparecem como filtros na visualização de Atividade da sua página de Perfil.",
  "account_edit_tags.max_tags_reached": "Você atingiu o número máximo de hashtags em destaque.",
  "account_edit_tags.search_placeholder": "Insira uma hashtag…",
  "account_edit_tags.suggestions": "Sugestões:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# publicação} other {# publicações}}",
  "account_list.hidden_notice": "Isto é visível somente para você. Para exibir para todos, vá a <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# conta} other {# contas}}",
  "admin.dashboard.daily_retention": "Taxa de retenção de usuários por dia, após a inscrição",
  "admin.dashboard.monthly_retention": "Taxa de retenção de usuários por mês, após a inscrição",
  "admin.dashboard.retention.average": "Média",
  "admin.dashboard.retention.cohort": "Mês de inscrição",
  "admin.dashboard.retention.cohort_size": "Novos usuários",
  "admin.impact_report.instance_accounts": "Perfis de contas que isso apagaria",
  "admin.impact_report.instance_followers": "Seguidores que os nossos usuários perderiam",
  "admin.impact_report.instance_follows": "Seguidores que os usuários deles perderiam",
  "admin.impact_report.title": "Resumo do impacto",
  "alert.need_reload.message": "O Mastodon foi atualizado. Algumas coisas podem não funcionar corretamente até você recarregar a página.",
  "alert.rate_limited.message": "Tente novamente após {retry_time, time, medium}.",
  "alert.rate_limited.title": "Tentativas limitadas",
  "alert.unexpected.message": "Ocorreu um erro inesperado.",
  "alert.unexpected.title": "Eita!",
  "alt_text_badge.title": "Texto alternativo",
  "alt_text_modal.add_alt_text": "Adicione texto alternativo",
  "alt_text_modal.add_text_from_image": "Adicione texto a partir da imagem",
  "alt_text_modal.cancel": "Cancelar",
  "alt_text_modal.change_thumbnail": "Alterar miniatura",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Descreva isto para pessoas com deficiências auditivas…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Descreva isto para pessoas com deficiências visuais…",
  "alt_text_modal.done": "Concluído",
  "announcement.announcement": "Anúncio",
  "annual_report.announcement.action_build": "Gerar meu Wrapstodon",
  "annual_report.announcement.action_dismiss": "Não, obrigado",
  "annual_report.announcement.action_view": "Ver meu Wrapstodon",
  "annual_report.announcement.description": "Descubra mais sobre seu engajamento no Mastodon ao longo do último ano.",
  "annual_report.announcement.title": "Chegou o Wrapstodon de {year}",
  "annual_report.nav_item.badge": "Novo",
  "annual_report.shared_page.donate": "Doar",
  "annual_report.shared_page.footer": "Criado com {heart} pela equipe do Mastodon",
  "annual_report.shared_page.footer_server_info": "{username} usa {domain}, uma de muitas comunidades baseadas no Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} se manteve na caça por publicações para impulsionar, amplificando outros criadores com uma mira perfeita.",
  "annual_report.summary.archetype.booster.desc_self": "Você se manteve na caça por publicações para impulsionar, amplificando outros criadores com uma mira perfeita.",
  "annual_report.summary.archetype.booster.name": "O Arqueiro",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Sabemos que {name} esteve por aí, em algum lugar, aproveitando o Mastodon do seu próprio jeito silencioso.",
  "annual_report.summary.archetype.lurker.desc_self": "Sabemos que você esteve por aí, em algum lugar, aproveitando o Mastodon do seu próprio jeito silencioso.",
  "annual_report.summary.archetype.lurker.name": "O Estoico",
  "annual_report.summary.archetype.oracle.desc_public": "{name} criou mais publicações novas que respostas, mantendo o Mastodon fresco e em direção ao futuro.",
  "annual_report.summary.archetype.oracle.desc_self": "Você criou mais publicações novas que respostas, mantendo o Mastodon fresco e em direção ao futuro.",
  "annual_report.summary.archetype.oracle.name": "O Oráculo",
  "annual_report.summary.archetype.pollster.desc_public": "{name} criou mais enquetes que quaisquer outros tipos de publicações, cultivando curiosidade no Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Você criou mais enquetes que quaisquer outros tipos de publicações, cultivando curiosidade no Mastodon.",
  "annual_report.summary.archetype.pollster.name": "O Questionador",
  "annual_report.summary.archetype.replier.desc_public": "{name} frequentemente respondeu às publicações de outras pessoas, polinizando o Mastodon com novas discussões.",
  "annual_report.summary.archetype.replier.desc_self": "Você frequentemente respondeu às publicações de outras pessoas, polinizando o Mastodon com novas discussões.",
  "annual_report.summary.archetype.replier.name": "A Borboleta",
  "annual_report.summary.archetype.reveal": "Revele meu arquétipo",
  "annual_report.summary.archetype.reveal_description": "Obrigado por ser parte do Mastodon! Está na hora de descobrir qual arquétipo você incorporou em {year}.",
  "annual_report.summary.archetype.title_public": "Arquétipo de {name}",
  "annual_report.summary.archetype.title_self": "Seu arquétipo",
  "annual_report.summary.close": "Fechar",
  "annual_report.summary.copy_link": "Copiar link",
  "annual_report.summary.followers.new_followers": "{count, plural, one {novo(a) seguidor(a)} other {novos seguidores}}",
  "annual_report.summary.highlighted_post.boost_count": "Esta publicação foi impulsionada {count, plural, one {uma vez} other {# vezes}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Esta publicação foi favoritada {count, plural, one {uma vez} other {# vezes}}.",
  "annual_report.summary.highlighted_post.reply_count": "Esta postagem recebeu {count, plural, one {uma resposta} other {# respostas}}.",
  "annual_report.summary.highlighted_post.title": "Publicação mais popular",
  "annual_report.summary.most_used_app.most_used_app": "aplicativo mais usado",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "hashtag mais usada",
  "annual_report.summary.most_used_hashtag.used_count": "Você incluiu esta hashtag em {count, plural, one {uma publicação} other {# publicações}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} incluiu esta hashtag em {count, plural, one {uma publicação} other {# publicações}}.",
  "annual_report.summary.new_posts.new_posts": "novas publicações",
  "annual_report.summary.percentile.text": "<topLabel>Isso lhe coloca no topo</topLabel><percentage></percentage><bottomLabel>de usuários de {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Não contaremos ao Bernie.",
  "annual_report.summary.share_elsewhere": "Compartilhar em outro lugar",
  "annual_report.summary.share_message": "Eu obtive o arquétipo {archetype}!",
  "annual_report.summary.share_on_mastodon": "Compartilhar no Mastodon",
  "attachments_list.unprocessed": "(não processado)",
  "audio.hide": "Ocultar áudio",
  "block_modal.no_collections": "Nenhum de vocês pode adicionar um ao outro a coleções. Vocês serão automaticamente removidos um da coleção do outro, se for o caso.",
  "block_modal.remote_users_caveat": "Pediremos ao servidor {domain} que respeite sua decisão. No entanto, a conformidade não é garantida, já que alguns servidores podem lidar com bloqueios de maneira diferente. As publicações abertas ainda podem estar visíveis para usuários não logados.",
  "block_modal.show_less": "Mostrar menos",
  "block_modal.show_more": "Mostrar mais",
  "block_modal.they_cant_mention": "Vocês não podem mencionar, seguir ou citar um ao outro.",
  "block_modal.they_cant_see_posts": "Vocês não podem ver o conteúdo um do outro.",
  "block_modal.they_will_know": "Poderá ver que você bloqueou.",
  "block_modal.title": "Bloquear usuário?",
  "block_modal.you_wont_see_mentions": "Você não verá publicações de outros que mencionem essa conta.",
  "boost_modal.combo": "Pressione {combo} para pular isto na próxima vez",
  "boost_modal.reblog": "Impulsionar a publicação?",
  "boost_modal.undo_reblog": "Retirar o impulso da publicação?",
  "bundle_column_error.copy_stacktrace": "Copiar relatório do erro",
  "bundle_column_error.error.body": "A página solicitada não pôde ser renderizada. Pode ser devido a um erro no nosso código, ou um problema de compatibilidade do seu navegador.",
  "bundle_column_error.error.title": "Ah, não!",
  "bundle_column_error.network.body": "Ocorreu um erro ao tentar carregar esta página. Isso pode ser devido a um problema temporário com sua conexão de internet ou deste servidor.",
  "bundle_column_error.network.title": "Erro de rede",
  "bundle_column_error.retry": "Tente novamente",
  "bundle_column_error.return": "Voltar à página inicial",
  "bundle_column_error.routing.body": "A página solicitada não foi encontrada. Tem certeza de que o URL na barra de endereços está correta?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Fechar",
  "bundle_modal_error.message": "Algo deu errado ao carregar esta tela.",
  "bundle_modal_error.retry": "Tente novamente",
  "callout.dismiss": "Rejeitar",
  "carousel.current": "<sr>Slide</sr> {current, number} / {max, number}",
  "carousel.slide": "Slide {current, number} de {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} caracteres sugeridos",
  "character_counter.required": "{currentLength}/{maxLength} caracteres",
  "closed_registrations.other_server_instructions": "Como o Mastodon é descentralizado, você pode criar uma conta em outro servidor e ainda pode interagir com este.",
  "closed_registrations_modal.description": "Não é possível criar uma conta em {domain} no momento, mas atente que você não precisa de uma conta especificamente em {domain} para usar o Mastodon.",
  "closed_registrations_modal.find_another_server": "Encontrar outro servidor",
  "closed_registrations_modal.preamble": "O Mastodon é descentralizado, não importa onde você criou a sua conta, será possível seguir e interagir com qualquer pessoa neste servidor. Você pode até mesmo criar o seu próprio servidor!",
  "closed_registrations_modal.title": "Inscrevendo-se no Mastodon",
  "collection.share_modal.share_link_label": "Compartilhar link",
  "collection.share_modal.share_via_post": "Publicar no Mastodon",
  "collection.share_modal.share_via_system": "Enviar para…",
  "collection.share_modal.title": "Compartilhar coleção",
  "collection.share_modal.title_new": "Compartilhe sua nova coleção!",
  "collection.share_template_other": "Confira esta coleção incrível:",
  "collection.share_template_own": "Confira minha nova coleção:",
  "collections.account_count": "{count, plural, one {# conta} other {# conta}}",
  "collections.accounts.empty_description": "Adicione até {count} contas",
  "collections.accounts.empty_editor_title": "Ainda não há ninguém nesta coleção",
  "collections.accounts.empty_title": "Esta coleção está vazia",
  "collections.add_to_collection": "Adicionar {name} à coleção",
  "collections.block_collection_owner": "Bloquear conta",
  "collections.by_account": "por {account_handle}",
  "collections.collection_description": "Descrição",
  "collections.collection_language": "Idioma",
  "collections.collection_language_none": "Nenhum",
  "collections.collection_name": "Nome",
  "collections.collection_topic": "Tópico",
  "collections.confirm_account_removal": "Tem certeza que deseja remover esta conta da sua coleção?",
  "collections.content_warning": "Alerta de conteúdo",
  "collections.continue": "Continuar",
  "collections.copy_link": "Copiar link",
  "collections.copy_link_confirmation": "Link de coleção copiado",
  "collections.create.accounts_title": "Quen você vai apresentar nesta coleção?",
  "collections.create.basic_details_title": "Detalhes básicos",
  "collections.create.steps": "Passo {step}/{total}",
  "collections.create_collection": "Criar coleção",
  "collections.create_new_collection": "Criar nova coleção",
  "collections.delete_collection": "Excluir coleção",
  "collections.description_length_hint": "Limite de 100 caracteres",
  "collections.detail.author_added_you_on_date": "{author} te adicionou em {date}",
  "collections.detail.loading": "Carregando coleção…",
  "collections.detail.revoke_inclusion": "Remover-me",
  "collections.detail.sensitive_content": "Conteúdo sensível",
  "collections.detail.sensitive_note": "A descrição e as contas podem não ser adequadas para todos os públicos.",
  "collections.detail.share": "Compartilhar esta coleção",
  "collections.detail.you_are_in_this_collection": "Você aparece nesta coleção",
  "collections.edit_details": "Editar detalhes",
  "collections.error_loading_collections": "Houve um erro ao tentar carregar estas coleções.",
  "collections.hidden_accounts_description": "Você bloqueou ou silencilou {count, plural, one{este usuário} other {estes usuários}}",
  "collections.hidden_accounts_link": "{count, plural, one {# conta oculta} other {# contas ocultas}}",
  "collections.hints.accounts_counter": "{count}/{max} contas",
  "collections.last_updated_at": "Atualizado pela última vez em {date}",
  "collections.list.collections_with_count": "{count, plural, one {# Coleção} other {# Coleções}}",
  "collections.list.created_by_author": "Criado por {name}",
  "collections.list.created_by_you": "Criadas por você",
  "collections.list.featuring_you": "Com você presente",
  "collections.manage_accounts": "Gerenciar contas",
  "collections.mark_as_sensitive": "Marcar como sensível",
  "collections.mark_as_sensitive_hint": "Oculta a descrição e as contas da coleção por trás de um aviso de conteúdo. O nome da coleção ainda será visível.",
  "collections.maximum_collection_count_description": "Seu servidor permite criar até {count} coleções.",
  "collections.maximum_collection_count_reached": "Você criou a quantidade máxima de coleções",
  "collections.name_length_hint": "limite de 40 caracteres",
  "collections.new_collection": "Nova coleção",
  "collections.pending_accounts.message": "Contas podem aparecer como pendentes quando estamos aguardando uma resposta do usuário ou de seu servidor. Apenas você pode ver contas pendentes.",
  "collections.pending_accounts.title": "Por que estou vendo contas pendentes?",
  "collections.remove_account": "Remover",
  "collections.report_collection": "Denunciar esta coleção",
  "collections.revoke_collection_inclusion": "Remover-me desta coleção",
  "collections.revoke_inclusion.confirmation": "Você foi removido de \"{collection}\"",
  "collections.revoke_inclusion.error": "Houve um erro, por favor tente novamente mais tarde.",
  "collections.search_accounts_label": "Buscar uma conta para adicionar",
  "collections.search_accounts_max_reached": "Você adicionou o número máximo de contas",
  "collections.sensitive": "Sensível",
  "collections.share_short": "Compartilhar",
  "collections.sort_alphabetical": "Alfabética",
  "collections.sort_by": "Ordenar por:",
  "collections.sort_date_added": "Data de inclusão",
  "collections.sort_last_active": "Última atividade",
  "collections.sort_most_followers": "Mais seguidores",
  "collections.suggestions.can_not_add": "Não pode ser adicionado",
  "collections.suggestions.can_not_add_desc": "Estas contas talvez não permitem aparecer na página Descobrir ou talvez estejam em um servidor que não suporte coleções.",
  "collections.suggestions.must_follow": "Você deve seguir primeiro",
  "collections.suggestions.must_follow_desc": "Estas contas revisam as solicitações de seguidores. Seguidores podem adicioná-los às coleções.",
  "collections.topic_hint": "Adicione uma hashtag que ajude a todos compreenderem o tópico da coleção.",
  "collections.topic_special_chars_hint": "Caracteres especiais não serão incluídos ao salvar",
  "collections.unlisted_collections_description": "Estes não aparecem em seu perfil para todos. Qualquer um com link pode descobri-los.",
  "collections.unlisted_collections_with_count": "Coleções não listadas ({count})",
  "collections.view_collection": "Ver coleção",
  "collections.visibility_public": "Público",
  "collections.visibility_public_hint": "Descobrível em resultados de busca e qualquer outra área de recomendações.",
  "collections.visibility_title": "Visibilidade",
  "collections.visibility_unlisted": "Não listado",
  "collections.visibility_unlisted_hint": "Visível apenas com um link. Oculto de resultados de buscas e recomendações.",
  "column.about": "Sobre",
  "column.blocks": "Usuários bloqueados",
  "column.bookmarks": "Salvos",
  "column.community": "Linha local",
  "column.create_list": "Criar lista",
  "column.direct": "Menções privadas",
  "column.directory": "Explorar perfis",
  "column.domain_blocks": "Domínios bloqueados",
  "column.edit_list": "Editar lista",
  "column.favourites": "Favoritos",
  "column.firehose": "Feeds ao vivo",
  "column.firehose_local": "Feed ao vivo do servidor",
  "column.firehose_singular": "Feed ao vivo",
  "column.follow_requests": "Seguidores pendentes",
  "column.home": "Página inicial",
  "column.list_members": "Gerenciar membros da lista",
  "column.lists": "Listas",
  "column.mutes": "Usuários silenciados",
  "column.notifications": "Notificações",
  "column.other_collections": "Coleções de {name}",
  "column.pins": "Publicações fixadas",
  "column.public": "Linha global",
  "column.your_collections": "Suas Coleções",
  "column_back_button.label": "Voltar",
  "column_header.hide_settings": "Ocultar configurações",
  "column_header.moveLeft_settings": "Mover coluna para a esquerda",
  "column_header.moveRight_settings": "Mover coluna para a direita",
  "column_header.pin": "Fixar",
  "column_header.show_settings": "Mostrar configurações",
  "column_header.unpin": "Desafixar",
  "column_search.cancel": "Cancelar",
  "combobox.close_results": "Fechar resultados",
  "combobox.loading": "Carregando",
  "combobox.no_results_found": "Sem resultados para esta busca",
  "combobox.open_results": "Abrir resultados",
  "combobox.results_available": "{count, plural, one {# sugestão disponível} other {# sugestões disponíveis}}. Use as setas para cima e para baixo para navegar. Pressione Enter para selecionar.",
  "community.column_settings.local_only": "Somente local",
  "community.column_settings.media_only": "Somente mídia",
  "community.column_settings.remote_only": "Somente global",
  "compose.error.blank_post": "A publicação não pode estar em branco.",
  "compose.language.change": "Alterar idioma",
  "compose.language.search": "Pesquisar idiomas...",
  "compose.published.body": "Publicado.",
  "compose.published.open": "Abrir",
  "compose.saved.body": "Publicação salva.",
  "compose_form.direct_message_warning_learn_more": "Saiba mais",
  "compose_form.encryption_warning": "As publicações no Mastodon não são criptografadas de ponta-a-ponta. Não compartilhe nenhuma informação sensível no Mastodon.",
  "compose_form.hashtag_warning": "Esta publicação não será exibida sob nenhuma hashtag, já que não é pública. Apenas publicações públicas podem ser pesquisadas por meio de hashtags.",
  "compose_form.lock_disclaimer": "Seu perfil não está {locked}. Qualquer um pode te seguir e ver as suas publicações privadas.",
  "compose_form.lock_disclaimer.lock": "trancado",
  "compose_form.placeholder": "No que você está pensando?",
  "compose_form.poll.duration": "Duração da enquete",
  "compose_form.poll.multiple": "Múltipla escolha",
  "compose_form.poll.option_placeholder": "Opção {number}",
  "compose_form.poll.single": "Única escolha",
  "compose_form.poll.switch_to_multiple": "Permitir múltiplas escolhas",
  "compose_form.poll.switch_to_single": "Opção única",
  "compose_form.poll.type": "Estilo",
  "compose_form.publish": "Publicar",
  "compose_form.reply": "Responder",
  "compose_form.save_changes": "Atualizar",
  "compose_form.spoiler.marked": "Com Aviso de Conteúdo",
  "compose_form.spoiler.unmarked": "Sem Aviso de Conteúdo",
  "compose_form.spoiler_placeholder": "Aviso de conteúdo (opcional)",
  "confirmation_modal.cancel": "Cancelar",
  "confirmations.block.confirm": "Bloquear",
  "confirmations.delete.confirm": "Excluir",
  "confirmations.delete.message": "Você tem certeza de que deseja excluir esta publicação?",
  "confirmations.delete.title": "Excluir publicação?",
  "confirmations.delete_collection.confirm": "Excluir",
  "confirmations.delete_collection.message": "Esta ação não pode ser desfeita.",
  "confirmations.delete_collection.title": "Excluir \"{name}\"?",
  "confirmations.delete_list.confirm": "Excluir",
  "confirmations.delete_list.message": "Você tem certeza de que deseja excluir esta lista?",
  "confirmations.delete_list.title": "Excluir lista?",
  "confirmations.discard_draft.confirm": "Descartar e continuar",
  "confirmations.discard_draft.edit.cancel": "Continuar editando",
  "confirmations.discard_draft.edit.message": "Continuar descartará quaisquer mudanças feitas à publicação sendo editada.",
  "confirmations.discard_draft.edit.title": "Descartar mudanças na sua publicação?",
  "confirmations.discard_draft.post.cancel": "Continuar rascunho",
  "confirmations.discard_draft.post.message": "Continuar eliminará a publicação que está sendo elaborada no momento.",
  "confirmations.discard_draft.post.title": "Eliminar seu rascunho de publicação?",
  "confirmations.discard_edit_media.confirm": "Descartar",
  "confirmations.discard_edit_media.message": "Há mudanças não salvas na descrição ou pré-visualização da mídia. Descartar assim mesmo?",
  "confirmations.follow_to_list.confirm": "Seguir e adicionar à lista",
  "confirmations.follow_to_list.message": "Você precisa seguir {name} para adicioná-lo à lista.",
  "confirmations.follow_to_list.title": "Seguir usuário?",
  "confirmations.hide_featured_tab.confirm": "Ocultar aba",
  "confirmations.hide_featured_tab.intro": "Você pode alterar isto a qualquer momento em <i>Editar Perfil > Configurações da aba de perfil</i>.",
  "confirmations.hide_featured_tab.message": "Isto ocultará a aba para usuários em {serverName} e outros servidores executando a versão mais recente do Mastodon. Outras exibições podem variar.",
  "confirmations.hide_featured_tab.title": "Ocultar aba \"Em destaque\"?",
  "confirmations.logout.confirm": "Sair",
  "confirmations.logout.message": "Você tem certeza de que deseja sair?",
  "confirmations.logout.title": "Sair da sessão?",
  "confirmations.missing_alt_text.confirm": "Adicione texto alternativo",
  "confirmations.missing_alt_text.message": "Seu post contém mídia sem texto alternativo. Adicionar descrições ajuda a tornar seu conteúdo acessível para mais pessoas.",
  "confirmations.missing_alt_text.secondary": "Publicar mesmo assim",
  "confirmations.missing_alt_text.title": "Adicionar texto alternativo?",
  "confirmations.mute.confirm": "Silenciar",
  "confirmations.private_quote_notify.cancel": "Voltar à edição",
  "confirmations.private_quote_notify.confirm": "Publicar citação",
  "confirmations.private_quote_notify.do_not_show_again": "Não me mostre esta mensagem novamente",
  "confirmations.private_quote_notify.message": "A pessoa que está sendo citada e outras mencionadas serão notificadas e poderão ver sua publicação, mesmo que não sigam você.",
  "confirmations.private_quote_notify.title": "Compartilhar com seguidores e usuários mencionados?",
  "confirmations.quiet_post_quote_info.dismiss": "Não me lembrar novamente",
  "confirmations.quiet_post_quote_info.got_it": "Entendi",
  "confirmations.quiet_post_quote_info.message": "Ao citar uma publicação silenciosa, sua publicação será oculta das timelines em alta.",
  "confirmations.quiet_post_quote_info.title": "Citando publicações públicas silenciosas",
  "confirmations.redraft.confirm": "Excluir e rascunhar",
  "confirmations.redraft.message": "Você tem certeza de que quer apagar esta publicação e rascunhá-la? Favoritos e impulsos serão perdidos, e respostas à publicação original ficarão órfãs.",
  "confirmations.redraft.title": "Excluir e rascunhar publicação?",
  "confirmations.remove_from_followers.confirm": "Remover seguidor",
  "confirmations.remove_from_followers.message": "{name} vai parar de te seguir. Tem certeza de que deseja continuar?",
  "confirmations.remove_from_followers.title": "Remover seguidor?",
  "confirmations.revoke_collection_inclusion.confirm": "Remover-me",
  "confirmations.revoke_collection_inclusion.message": "Este curador não poderá re-adicioná-lo a esta coleção por 24 horas. Para impedir permanentemente que adicionem você às coleções, você pode bloqueá-los.",
  "confirmations.revoke_collection_inclusion.title": "Remover-se desta coleção?",
  "confirmations.revoke_quote.confirm": "Remover publicação",
  "confirmations.revoke_quote.message": "Esta ação não pode ser desfeita.",
  "confirmations.revoke_quote.title": "Remover publicação?",
  "confirmations.unblock.confirm": "Desbloquear",
  "confirmations.unblock.title": "Desbloquear {name}?",
  "confirmations.unfollow.confirm": "Deixar de seguir",
  "confirmations.unfollow.title": "Deixar de seguir {name}?",
  "confirmations.withdraw_request.confirm": "Retirar solicitação",
  "confirmations.withdraw_request.title": "Retirar solicitação para seguir {name}?",
  "content_warning.hide": "Ocultar publicação",
  "content_warning.show": "Mostrar mesmo assim",
  "content_warning.show_more": "Mostrar mais",
  "content_warning.show_short": "Exibir",
  "conversation.delete": "Excluir conversa",
  "conversation.mark_as_read": "Marcar como lida",
  "conversation.open": "Ver conversa",
  "conversation.with": "Com {names}",
  "copy_icon_button.copied": "Copiado para a área de transferência",
  "copy_icon_button.copy_this_text": "Copiar link para área de transferência",
  "copypaste.copied": "Copiado",
  "copypaste.copy_to_clipboard": "Copiar para a área de transferência",
  "custom_homepage.about": "Sobre",
  "custom_homepage.about_this_server": "Sobre este servidor",
  "custom_homepage.administered_by": "Administrado por",
  "custom_homepage.contact": "Contato:",
  "custom_homepage.latest_activity": "Última atividade",
  "custom_homepage.these_are_the_latest_posts": "Estas são as últimas 40 publicações das contas neste servidor.",
  "directory.federated": "Do fediverso conhecido",
  "directory.local": "Somente de {domain}",
  "directory.new_arrivals": "Acabaram de chegar",
  "directory.recently_active": "Ativos recentemente",
  "disabled_account_banner.account_settings": "Configurações da conta",
  "disabled_account_banner.text": "Sua conta {disabledAccount} está desativada no momento.",
  "dismissable_banner.community_timeline": "Estas são as publicações abertas mais recentes das pessoas cujas contas são hospedadas por {domain}.",
  "dismissable_banner.dismiss": "Dispensar",
  "dismissable_banner.public_timeline": "Estas são as publicações mais recentes das pessoas no fediverso que as pessoas do {domain} seguem.",
  "domain_block_modal.block": "Bloquear servidor",
  "domain_block_modal.block_account_instead": "Bloquear @{name} em vez disso",
  "domain_block_modal.they_can_interact_with_old_posts": "Pessoas deste servidor podem interagir com suas publicações antigas.",
  "domain_block_modal.they_cant_follow": "Ninguém deste servidor pode lhe seguir.",
  "domain_block_modal.they_wont_know": "O/A usuário/a não saberá que foi bloqueado/a.",
  "domain_block_modal.title": "Bloquear domínio?",
  "domain_block_modal.you_will_lose_num_followers": "Você perderá {followersCount, plural, one {{followersCountDisplay} seguidor} other {{followersCountDisplay} seguidores}} e {followingCount, plural, one {{followingCountDisplay} pessoa que você segue} other {{followingCountDisplay} pessoas que você segue}}.",
  "domain_block_modal.you_will_lose_relationships": "Você irá perder todos os seguidores e pessoas que você segue neste servidor.",
  "domain_block_modal.you_wont_see_posts": "Você não verá publicações ou notificações de usuários neste servidor.",
  "dropdown.empty": "Escolha uma opção",
  "email_subscriptions.email": "Email",
  "email_subscriptions.form.action": "Inscrever-se",
  "email_subscriptions.form.bottom": "Receba publicações em sua caixa de entrada sem criar uma conta do Mastodon. Desinscreva-se a qualquer momento. Para mais informações, consulte a <a>Política de Privacidade</a>.",
  "email_subscriptions.form.title": "Inscrever-se para atualizações por email de {name}",
  "email_subscriptions.submitted.lead": "Verifique a caixa de entrada por algum e-mail para encerrar inscrição de atualizações por e-mail.",
  "email_subscriptions.submitted.title": "Mais um passo",
  "email_subscriptions.validation.email.blocked": "Fornecedor de e-mail bloqueado",
  "email_subscriptions.validation.email.invalid": "Endereço de email inválido",
  "embed.instructions": "Incorpore esta publicação no seu site ao copiar o código abaixo.",
  "embed.preview": "Aqui está como vai ficar:",
  "emoji_button.activity": "Atividade",
  "emoji_button.clear": "Limpar",
  "emoji_button.custom": "Personalizados",
  "emoji_button.flags": "Bandeiras",
  "emoji_button.food": "Comida e Bebida",
  "emoji_button.label": "Adicionar emoji",
  "emoji_button.nature": "Natureza",
  "emoji_button.not_found": "Sem emojis! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Objetos",
  "emoji_button.people": "Pessoas",
  "emoji_button.recent": "Mais usados",
  "emoji_button.search": "Pesquisar...",
  "emoji_button.search_results": "Resultado da pesquisa",
  "emoji_button.symbols": "Símbolos",
  "emoji_button.travel": "Viagem e Lugares",
  "empty_column.account_featured.other": "{acct} não destacou nada ainda.",
  "empty_column.account_featured_self.no_collections_button": "Criar uma coleção",
  "empty_column.account_featured_self.no_collections_hide_tab": "Ao invés, ocultar esta aba",
  "empty_column.account_featured_self.showcase_accounts": "Exibir contas favoritas",
  "empty_column.account_featured_self.showcase_accounts_desc": "Coleções são listas curadas de contas para ajudar todos a descobrir mais do Fediverso.",
  "empty_column.account_featured_unknown.other": "Esta conta não destacou nada ainda.",
  "empty_column.account_hides_collections": "O usuário decidiu não tornar esta informação disponível",
  "empty_column.account_suspended": "Conta suspensa",
  "empty_column.account_timeline": "Nada aqui.",
  "empty_column.account_unavailable": "Perfil indisponível",
  "empty_column.blocks": "Nada aqui.",
  "empty_column.bookmarked_statuses": "Nada aqui. Quando você salvar uma publicação, ela aparecerá aqui.",
  "empty_column.collections": "{acct} não criou nenhuma coleção ainda.",
  "empty_column.collections.featured_in": "Você ainda não foi adicionado a nenhuma coleção.",
  "empty_column.collections.featured_in_undiscoverable": "Para as pessoas adicionarem você às coleções, você precisa permitir destaque em experiências de descoberta através de <link>Preferências > Privacidade e alcance</link>",
  "empty_column.collections_self": "Você ainda não criou nenhuma coleção.",
  "empty_column.community": "A linha local está vazia. Publique algo para começar!",
  "empty_column.direct": "Você ainda não tem mensagens privadas. Quando você enviar ou receber uma, será exibida aqui.",
  "empty_column.disabled_feed": "Este feed foi desativado pelos administradores de seu servidor.",
  "empty_column.domain_blocks": "Nada aqui.",
  "empty_column.explore_statuses": "Nada está em alta no momento. Volte mais tarde!",
  "empty_column.favourited_statuses": "Você ainda não tem publicações favoritas. Quanto você marcar uma como favorita, ela aparecerá aqui.",
  "empty_column.favourites": "Ninguém marcou esta publicação como favorita até agora. Quando alguém o fizer, será listado aqui.",
  "empty_column.follow_requests": "Nada aqui. Quando você tiver seguidores pendentes, eles aparecerão aqui.",
  "empty_column.followed_tags": "Você ainda não seguiu nenhuma hashtag. Quando seguir, elas serão exibidas aqui.",
  "empty_column.hashtag": "Nada aqui.",
  "empty_column.home": "Sua página inicial está vazia! Siga mais pessoas para preenchê-la.",
  "empty_column.list": "Nada aqui. Quando membros da lista publicarem, elas aparecerão aqui.",
  "empty_column.mutes": "Nada aqui.",
  "empty_column.notification_requests": "Tudo limpo! Não há nada aqui. Quando você receber novas notificações, elas aparecerão aqui de acordo com suas configurações.",
  "empty_column.notifications": "Interaja com outros usuários para começar a conversar.",
  "empty_column.public": "Publique algo ou siga manualmente usuários de outros servidores",
  "empty_state.no_results": "Sem resultados",
  "error.no_hashtag_feed_access": "Se cadastre ou faça login para ver e seguir esta hashtag.",
  "error.unexpected_crash.explanation": "Esta página não pôde ser mostrada corretamente. Este erro provavelmente é devido a um bug em nosso código ou um problema de compatibilidade de navegador.",
  "error.unexpected_crash.explanation_addons": "Esta página não pôde ser mostrada corretamente. Este erro provavelmente é causado por um complemento do navegador ou ferramentas de tradução automática.",
  "error.unexpected_crash.next_steps": "Tente atualizar a página. Se isso não ajudar, você ainda poderá usar o Mastodon por meio de um navegador diferente ou de um aplicativo nativo.",
  "error.unexpected_crash.next_steps_addons": "Tente desativá-los e atualizar a página. Se isso não ajudar, você ainda poderá usar o Mastodon por meio de um navegador diferente ou de um aplicativo nativo.",
  "errors.unexpected_crash.copy_stacktrace": "Copiar dados do erro para área de transferência",
  "errors.unexpected_crash.report_issue": "Reportar problema",
  "explore.suggested_follows": "Pessoas",
  "explore.title": "Em alta",
  "explore.trending_links": "Notícias",
  "explore.trending_statuses": "Publicações",
  "explore.trending_tags": "Hashtags",
  "featured_carousel.current": "<sr>Publicação</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Publicação fixada} other {Publicações fixadas}}",
  "featured_carousel.slide": "Publicação {current, number} de {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Recentemente, você publicou sobre {items}. Adicioná-los como hashtags destacadas?",
  "featured_tags.suggestions.add": "Adicionar",
  "featured_tags.suggestions.added": "Gerencie as hashtags destacadas em <link>Editar perfil > Hashtags destacadas</link>.",
  "featured_tags.suggestions.dismiss": "Não, obrigado",
  "filter_modal.added.context_mismatch_explanation": "Esta categoria de filtro não se aplica ao contexto no qual você acessou esta publicação. Se quiser que a publicação seja filtrada nesse contexto também, você terá que editar o filtro.",
  "filter_modal.added.context_mismatch_title": "Incompatibilidade de contexto!",
  "filter_modal.added.expired_explanation": "Esta categoria de filtro expirou, você precisará alterar a data de expiração para aplicar.",
  "filter_modal.added.expired_title": "Filtro expirado!",
  "filter_modal.added.review_and_configure": "Para revisar e configurar ainda mais esta categoria de filtro, vá para {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Configurações de filtro",
  "filter_modal.added.settings_link": "página de configurações",
  "filter_modal.added.short_explanation": "Esta publicação foi adicionada à seguinte categoria de filtro: {title}.",
  "filter_modal.added.title": "Filtro adicionado!",
  "filter_modal.select_filter.context_mismatch": "não se aplica a este contexto",
  "filter_modal.select_filter.expired": "expirado",
  "filter_modal.select_filter.prompt_new": "Nova categoria: {name}",
  "filter_modal.select_filter.search": "Buscar ou criar",
  "filter_modal.select_filter.subtitle": "Use uma categoria existente ou crie uma nova",
  "filter_modal.select_filter.title": "Filtrar esta publicação",
  "filter_modal.title.status": "Filtrar uma publicação",
  "filter_warning.matches_filter": "Corresponde ao filtro “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "De {count, plural, =0 {ninguém} one {uma pessoa} other {# pessoas}} que você talvez conheça",
  "filtered_notifications_banner.title": "Notificações filtradas",
  "firehose.all": "Tudo",
  "firehose.local": "Este servidor",
  "firehose.remote": "Outros servidores",
  "follow_request.authorize": "Aprovar",
  "follow_request.reject": "Recusar",
  "follow_requests.unlocked_explanation": "Apesar de seu perfil não ser trancado, {domain} exige que você revise a solicitação para te seguir destes perfis manualmente.",
  "follow_suggestions.curated_suggestion": "Escolha da equipe",
  "follow_suggestions.dismiss": "Não mostrar novamente",
  "follow_suggestions.featured_longer": "Escolhido à mão pela equipe de {domain}",
  "follow_suggestions.friends_of_friends_longer": "Em alta entre as pessoas que você segue",
  "follow_suggestions.hints.featured": "Este perfil foi escolhido à mão pela equipe de {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Este perfil está em alta entre as pessoas que você segue.",
  "follow_suggestions.hints.most_followed": "Este perfil é um dos mais seguidos em {domain}.",
  "follow_suggestions.hints.most_interactions": "Este perfil recentemente ganhou bastante atenção em {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Este perfil é semelhante aos perfis que você seguiu recentemente.",
  "follow_suggestions.personalized_suggestion": "Sugestão personalizada",
  "follow_suggestions.popular_suggestion": "Sugestão em alta",
  "follow_suggestions.popular_suggestion_longer": "Em alta em {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Semelhante aos perfis que você seguiu recentemente",
  "follow_suggestions.view_all": "Ver tudo",
  "follow_suggestions.who_to_follow": "Quem seguir",
  "followed_tags": "Hashtags seguidas",
  "followers.hide_other_followers": "O usuário decidiu não deixar seus seguidores visíveis",
  "followers.title": "Seguindo {name}",
  "following.hide_other_following": "O usuário decidiu não deixar quem eles seguem visível",
  "following.title": "Seguido por {name}",
  "footer.about": "Sobre",
  "footer.about_mastodon": "Sobre o Mastodon",
  "footer.about_server": "Sobre {domain}",
  "footer.about_this_server": "Sobre",
  "footer.directory": "Diretório de perfis",
  "footer.get_app": "Baixe o app",
  "footer.keyboard_shortcuts": "Atalhos de teclado",
  "footer.privacy_policy": "Política de privacidade",
  "footer.source_code": "Ver código-fonte",
  "footer.status": "Status",
  "footer.terms_of_service": "Termos de serviço",
  "form_error.blank": "O campo não pode estar vazio.",
  "form_field.optional": "(opcional)",
  "getting_started.heading": "Primeiros passos",
  "hashtag.admin_moderation": "Abrir menu de moderação para #{name}",
  "hashtag.browse": "Buscar publicações em #{hashtag}",
  "hashtag.browse_from_account": "Buscar publicações de @{name} em #{hashtag}",
  "hashtag.column_header.tag_mode.all": "e {additional}",
  "hashtag.column_header.tag_mode.any": "ou {additional}",
  "hashtag.column_header.tag_mode.none": "sem {additional}",
  "hashtag.column_settings.select.no_options_message": "Sem sugestões",
  "hashtag.column_settings.select.placeholder": "Insira hashtags…",
  "hashtag.column_settings.tag_mode.all": "Todas",
  "hashtag.column_settings.tag_mode.any": "Qualquer uma",
  "hashtag.column_settings.tag_mode.none": "Nenhuma",
  "hashtag.column_settings.tag_toggle": "Adicionar mais hashtags aqui",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} participante} other {{counter} participantes}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} publicação} other {{counter} publicações}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} publicação} other {{counter} publicações}} hoje",
  "hashtag.feature": "Destacar no perfil",
  "hashtag.follow": "Seguir hashtag",
  "hashtag.mute": "Silenciar #{hashtag}",
  "hashtag.unfeature": "Remover destaque",
  "hashtag.unfollow": "Parar de seguir hashtag",
  "hashtags.and_other": "…e {count, plural, other {mais #}}",
  "hints.profiles.followers_may_be_missing": "Alguns seguidores deste perfil podem estar faltando.",
  "hints.profiles.follows_may_be_missing": "Alguns seguidos deste perfil podem estar faltando.",
  "hints.profiles.posts_may_be_missing": "Algumas publicações deste perfil podem estar faltando.",
  "hints.profiles.see_more_followers": "Ver mais seguidores em {domain}",
  "hints.profiles.see_more_follows": "Ver mais perfis seguidos em {domain}",
  "hints.profiles.see_more_posts": "Ver mais publicações em {domain}",
  "home.column_settings.show_quotes": "Exibir citações",
  "home.column_settings.show_reblogs": "Mostrar impulsos",
  "home.column_settings.show_replies": "Mostrar respostas",
  "home.hide_announcements": "Ocultar anúncios",
  "home.pending_critical_update.body": "Por favor, atualize o seu servidor Mastodon o mais rápido possível!",
  "home.pending_critical_update.link": "Ver atualizações",
  "home.pending_critical_update.title": "Atualização de segurança crítica disponível!",
  "home.show_announcements": "Mostrar anúncios",
  "ignore_notifications_modal.bots_title": "Ignorar notificações de robôs?",
  "ignore_notifications_modal.disclaimer": "O Mastodon não pode informar aos usuários que você ignorou suas notificações. Ignorar notificações não impedirá que as próprias mensagens sejam enviadas.",
  "ignore_notifications_modal.filter_instead": "Filtrar em vez disso",
  "ignore_notifications_modal.filter_to_act_users": "Você ainda conseguirá aceitar, rejeitar ou denunciar usuários",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Os filtros ajudam a evitar potenciais confusões",
  "ignore_notifications_modal.filter_to_review_separately": "Você pode rever notificações filtradas separadamente",
  "ignore_notifications_modal.ignore": "Ignorar notificações",
  "ignore_notifications_modal.limited_accounts_title": "Ignorar notificações de contas moderadas?",
  "ignore_notifications_modal.new_accounts_title": "Ignorar notificações de novas contas?",
  "ignore_notifications_modal.not_followers_title": "Ignorar notificações de pessoas que não seguem você?",
  "ignore_notifications_modal.not_following_title": "Ignorar notificações de pessoas que você não segue?",
  "ignore_notifications_modal.private_mentions_title": "Ignorar notificações de menções privadas não solicitadas?",
  "info_button.label": "Ajuda",
  "info_button.what_is_alt_text": "<h1>O que é texto alternativo?</h1> <p>O texto alternativo descreve imagens para pessoas com deficiências visuais, conexões lentas ou para quem necessita de contexto adicional.</p> <p>Você pode melhorar a acessibilidade e compreensão de todos escrevendo um texto alternativo claro, conciso e objetivo.</p> <ul> <li>Capture elementos importantes</li> <li>Resuma o texto das imagens</li> <li>Use uma estrutura regular de frases</li> <li>Evite informações redundantes</li> <li>Foque em tendências e buscas em visuais complexos (como diagramas e mapas)</li> </ul>",
  "interaction_modal.action": "Para interagir com a publicação de {name}, você precisa registrar em sua conta em qualquer servidor do Mastodon.",
  "interaction_modal.action_follow": "Para seguir {name}, você precisa registrar em sua conta em qualquer servidor do Mastodon.",
  "interaction_modal.go": "Ir",
  "interaction_modal.no_account_yet": "Não tem uma conta ainda?",
  "interaction_modal.on_another_server": "Em um servidor diferente",
  "interaction_modal.on_this_server": "Neste servidor",
  "interaction_modal.title": "Registre-se para continuar",
  "interaction_modal.username_prompt": "Por exemplo: {example}",
  "intervals.full.days": "{number, plural, one {# dia} other {# dias}}",
  "intervals.full.hours": "{number, plural, one {# hora} other {# horas}}",
  "intervals.full.minutes": "{number, plural, one {# minuto} other {# minutos}}",
  "keyboard_shortcuts.back": "voltar",
  "keyboard_shortcuts.blocked": "abrir usuários bloqueados",
  "keyboard_shortcuts.boost": "Impulsionar a publicação",
  "keyboard_shortcuts.column": "focar na coluna",
  "keyboard_shortcuts.compose": "focar no compositor",
  "keyboard_shortcuts.description": "Descrição",
  "keyboard_shortcuts.direct": "Abrir coluna de menções privadas",
  "keyboard_shortcuts.down": "mover para baixo",
  "keyboard_shortcuts.enter": "Abrir publicação",
  "keyboard_shortcuts.explore": "Abrir timeline em alta",
  "keyboard_shortcuts.favourite": "Favoritar publicação",
  "keyboard_shortcuts.favourites": "Abrir lista de favoritos",
  "keyboard_shortcuts.federated": "abrir linha global",
  "keyboard_shortcuts.heading": "Atalhos de teclado",
  "keyboard_shortcuts.home": "abrir página inicial",
  "keyboard_shortcuts.hotkey": "Atalho",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Backspace",
  "keyboard_shortcuts.keys.enter": "Enter",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "Page Down",
  "keyboard_shortcuts.keys.page_up": "Page Up",
  "keyboard_shortcuts.legend": "mostrar estes atalhos",
  "keyboard_shortcuts.load_more": "Focar no botão de Carregar mais",
  "keyboard_shortcuts.local": "abrir linha local",
  "keyboard_shortcuts.mention": "mencionar usuário",
  "keyboard_shortcuts.muted": "abrir usuários silenciados",
  "keyboard_shortcuts.my_profile": "abrir seu perfil",
  "keyboard_shortcuts.notifications": "abrir notificações",
  "keyboard_shortcuts.open_media": "abrir mídia",
  "keyboard_shortcuts.pinned": "Abrir publicações fixadas",
  "keyboard_shortcuts.profile": "abrir perfil do usuário",
  "keyboard_shortcuts.quote": "Citar publicação",
  "keyboard_shortcuts.reply": "Responder publicação",
  "keyboard_shortcuts.requests": "abrir seguidores pendentes",
  "keyboard_shortcuts.search": "Focar na barra de busca",
  "keyboard_shortcuts.spoilers": "ativar/desativar aviso de conteúdo",
  "keyboard_shortcuts.start": "abrir primeiros passos",
  "keyboard_shortcuts.toggle_hidden": "Expandir/ocultar aviso de conteúdo",
  "keyboard_shortcuts.toggle_sensitivity": "mostrar/ocultar mídia",
  "keyboard_shortcuts.toot": "Começar nova publicação",
  "keyboard_shortcuts.top": "Mover para o topo da lista",
  "keyboard_shortcuts.translate": "Traduzir uma publicação",
  "keyboard_shortcuts.unfocus": "Tirar o foco da área de redação/busca",
  "keyboard_shortcuts.up": "mover para cima",
  "learn_more_link.got_it": "Entendido",
  "learn_more_link.learn_more": "Veja mais",
  "lightbox.close": "Fechar",
  "lightbox.next": "Próximo",
  "lightbox.previous": "Anterior",
  "lightbox.zoom_in": "Retornar ao tamanho real",
  "lightbox.zoom_out": "Zoom para ajustar",
  "limited_account_hint.action": "Exibir perfil mesmo assim",
  "limited_account_hint.title": "Este perfil ou servidor foi ocultado pelos moderadores de {domain}.",
  "link_preview.author": "Por {name}",
  "link_preview.more_from_author": "Mais de {name}",
  "link_preview.shares": "{count, plural, one {{counter} publicação} other {{counter} publicações}}",
  "lists.add_member": "Adicionar",
  "lists.add_to_list": "Adicionar à lista",
  "lists.add_to_lists": "Adicionar {name} às listas",
  "lists.create": "Criar",
  "lists.create_a_list_to_organize": "Criar uma lista para organizar seu feed inicial",
  "lists.create_list": "Criar lista",
  "lists.delete": "Excluir lista",
  "lists.done": "Concluído",
  "lists.edit": "Editar lista",
  "lists.exclusive": "Ocultar membros no início",
  "lists.exclusive_hint": "Se alguém estiver nesta lista, oculte-os no seu feed inicial para evitar ver suas publicações duas vezes.",
  "lists.find_users_to_add": "Encontrar usuários para adicionar",
  "lists.list_members_count": "{count, plural, one {# membro} other {# membros}}",
  "lists.list_name": "Nome da lista",
  "lists.new_list_name": "Nome da nova lista",
  "lists.no_lists_yet": "Sem listas.",
  "lists.no_members_yet": "Nenhum membro.",
  "lists.no_results_found": "Nenhum resultado encontrado.",
  "lists.remove_member": "Remover",
  "lists.replies_policy.followed": "Qualquer usuário seguido",
  "lists.replies_policy.list": "Membros da lista",
  "lists.replies_policy.none": "Ninguém",
  "lists.save": "Salvar",
  "lists.search": "Buscar",
  "lists.show_replies_to": "Incluir respostas de membros da lista para",
  "load_pending": "{count, plural, one {# novo item} other {# novos itens}}",
  "loading_indicator.label": "Carregando…",
  "media_gallery.hide": "Ocultar",
  "moved_to_account_banner.text": "Sua conta {disabledAccount} está desativada porque você a moveu para {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Ocultar das notificações",
  "mute_modal.hide_options": "Ocultar opções",
  "mute_modal.indefinite": "Até eu os dessilenciar",
  "mute_modal.show_options": "Mostrar opções",
  "mute_modal.they_can_mention_and_follow": "Eles podem mencionar e seguir você, mas você não os verá.",
  "mute_modal.they_wont_know": "Eles não saberão que foram silenciados.",
  "mute_modal.title": "Silenciar usuário?",
  "mute_modal.you_wont_see_mentions": "Você não verá publicações que os mencionem.",
  "mute_modal.you_wont_see_posts": "Eles ainda poderão ver suas publicações, mas você não verá as deles.",
  "navigation_bar.about": "Sobre",
  "navigation_bar.account_settings": "Senha e segurança",
  "navigation_bar.administration": "Administração",
  "navigation_bar.advanced_interface": "Abrir na interface web avançada",
  "navigation_bar.automated_deletion": "Exclusão automática de publicações",
  "navigation_bar.blocks": "Usuários bloqueados",
  "navigation_bar.bookmarks": "Salvos",
  "navigation_bar.collections": "Coleções",
  "navigation_bar.direct": "Menções privadas",
  "navigation_bar.domain_blocks": "Domínios bloqueados",
  "navigation_bar.favourites": "Favoritos",
  "navigation_bar.filters": "Palavras filtradas",
  "navigation_bar.follow_requests": "Seguidores pendentes",
  "navigation_bar.followed_tags": "Hashtags seguidas",
  "navigation_bar.follows_and_followers": "Segue e seguidores",
  "navigation_bar.import_export": "Importar e exportar",
  "navigation_bar.lists": "Listas",
  "navigation_bar.live_feed_local": "Feed ao vivo (local)",
  "navigation_bar.live_feed_public": "Feed ao vivo (público)",
  "navigation_bar.logout": "Sair",
  "navigation_bar.main": "Principal",
  "navigation_bar.moderation": "Moderação",
  "navigation_bar.more": "Mais",
  "navigation_bar.mutes": "Usuários silenciados",
  "navigation_bar.opened_in_classic_interface": "As publicações, contas e outras páginas são abertas por padrão na interface web clássica.",
  "navigation_bar.preferences": "Preferências",
  "navigation_bar.privacy_and_reach": "Privacidade e alcance",
  "navigation_bar.search": "Buscar",
  "navigation_bar.search_trends": "Busca / Em alta",
  "navigation_panel.collapse_followed_tags": "Recolher hashtags seguidas",
  "navigation_panel.collapse_lists": "Recolher menu da lista",
  "navigation_panel.expand_followed_tags": "Expandir hashtags seguidas",
  "navigation_panel.expand_lists": "Expandir menu da lista",
  "not_signed_in_indicator.not_signed_in": "É necessário registrar para acessar este recurso.",
  "notification.added_to_collection": "{name} adicionou você a uma coleção",
  "notification.admin.report": "{name} denunciou {target}",
  "notification.admin.report_account": "{name} denunciou {count, plural, one {uma publicação} other {# publicações}} de {target} para {category}",
  "notification.admin.report_account_other": "{name} denunciou {count, plural, one {uma publicação} other {# publicações}} de {target}",
  "notification.admin.report_statuses": "{name} denunciou {target} para {category}",
  "notification.admin.report_statuses_other": "{name} denunciou {target}",
  "notification.admin.sign_up": "{name} registrou-se",
  "notification.admin.sign_up.name_and_others": "{name} e {count, plural, one {# other} other {# outros}}",
  "notification.annual_report.message": "O #Wrapstodon de {year} lhe aguarda! Desvende seus destaques e momentos memoráveis do ano no Mastodon!",
  "notification.annual_report.view": "Conferir #Wrapstodon",
  "notification.collection_update": "{name} editou uma coleção em que você está",
  "notification.favourite": "{name} favoritou sua publicação",
  "notification.favourite.name_and_others_with_link": "{name} e <a>{count, plural, one {# outro} other {# outros}}</a> favoritam sua publicação",
  "notification.favourite_pm": "{name} favoritou sua menção privada",
  "notification.favourite_pm.name_and_others_with_link": "{name} e <a>{count, plural, one {# outro} other {# outros}}</a> favoritaram sua menção privada",
  "notification.follow": "{name} te seguiu",
  "notification.follow.name_and_others": "{name} e <a>{count, plural, one {# outro} other {# outros}}</a> seguiram você",
  "notification.follow_request": "{name} quer te seguir",
  "notification.follow_request.name_and_others": "{name} e {count, plural, one {# outro} other {# outros}} pediram para seguir você",
  "notification.label.mention": "Menção",
  "notification.label.private_mention": "Menção privada",
  "notification.label.private_reply": "Resposta privada",
  "notification.label.quote": "{name} citou sua publicação",
  "notification.label.reply": "Resposta",
  "notification.mention": "Menção",
  "notification.mentioned_you": "{name} mencionou você",
  "notification.moderation-warning.learn_more": "Saiba mais",
  "notification.moderation_warning": "Você recebeu um aviso de moderação",
  "notification.moderation_warning.action_delete_statuses": "Algumas publicações suas foram removidas.",
  "notification.moderation_warning.action_disable": "Sua conta foi desativada.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Algumas publicações suas foram marcadas como sensíveis.",
  "notification.moderation_warning.action_none": "Sua conta recebeu um aviso de moderação.",
  "notification.moderation_warning.action_sensitive": "Suas publicações serão marcadas como sensíveis a partir de agora.",
  "notification.moderation_warning.action_silence": "Sua conta foi limitada.",
  "notification.moderation_warning.action_suspend": "Sua conta foi suspensa.",
  "notification.own_poll": "Sua enquete terminou",
  "notification.poll": "Uma enquete que você votou encerrou",
  "notification.quoted_update": "{name} editou uma publicação que você citou",
  "notification.reblog": "{name} impulsionou sua publicação",
  "notification.reblog.name_and_others_with_link": "{name} e <a>{count, plural, one {# outro} other {# outros}}</a> impulsionaram sua publicação",
  "notification.relationships_severance_event": "Conexões perdidas com {name}",
  "notification.relationships_severance_event.account_suspension": "Um administrador de {from} suspendeu {target}, significando que você não receberá mais atualizações ou poderá interagir com ele.",
  "notification.relationships_severance_event.domain_block": "Um administrador de {from} bloqueou {target}, incluindo {followersCount} de seus seguidores e {followingCount, plural, one {# conta} other {# contas}} que você segue.",
  "notification.relationships_severance_event.learn_more": "Saiba mais",
  "notification.relationships_severance_event.user_domain_block": "Você bloqueou {target}, removendo {followersCount} de seus seguidores e {followingCount, plural, one {# conta} other {# contas}} que você segue.",
  "notification.status": "{name} acabou de publicar",
  "notification.update": "{name} editou uma publicação",
  "notification_requests.accept": "Aceitar",
  "notification_requests.accept_multiple": "{count, plural, one {Aceitar # pedido…} other {Aceitar # pedidos…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Aceitar pedido} other {Aceitar pedidos}}",
  "notification_requests.confirm_accept_multiple.message": "Você está prestes a aceitar {count, plural, one {um pedido de notificação} other {# pedidos de notificação}}. Deseja mesmo continuar?",
  "notification_requests.confirm_accept_multiple.title": "Aceitar pedidos de notificação?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Rejeitar pedido} other {Rejeitar pedidos}}",
  "notification_requests.confirm_dismiss_multiple.message": "Você está prestes a rejeitar {count, plural, one {um pedido de notificação} other {# pedidos de notificação}}. Você não conseguirá mais acessá{count, plural, one {-lo} other {-los}} facilmente de novo. Deseja mesmo continuar?",
  "notification_requests.confirm_dismiss_multiple.title": "Rejeitar pedidos de notificação?",
  "notification_requests.dismiss": "Rejeitar",
  "notification_requests.dismiss_multiple": "{count, plural, one {Rejeitar # pedido…} other {Rejeitar # pedidos…}}",
  "notification_requests.edit_selection": "Editar",
  "notification_requests.exit_selection": "Concluído",
  "notification_requests.explainer_for_limited_account": "As notificações desta conta foram filtradas porque a conta foi limitada por um moderador.",
  "notification_requests.explainer_for_limited_remote_account": "As notificações desta conta foram filtradas porque a conta ou o servidor foi limitado por um servidor.",
  "notification_requests.maximize": "Maximizar",
  "notification_requests.minimize_banner": "Minimizar banner de notificações filtradas",
  "notification_requests.notifications_from": "Notificações de {name}",
  "notification_requests.title": "Notificações filtradas",
  "notification_requests.view": "Ver notificações",
  "notifications.clear": "Limpar notificações",
  "notifications.clear_confirmation": "Você tem certeza de que deseja limpar todas as suas notificações?",
  "notifications.clear_title": "Limpar notificações?",
  "notifications.column_settings.admin.report": "Novas denúncias:",
  "notifications.column_settings.admin.sign_up": "Novos registros:",
  "notifications.column_settings.alert": "Notificações no computador",
  "notifications.column_settings.collections": "Coleções:",
  "notifications.column_settings.favourite": "Favoritos:",
  "notifications.column_settings.filter_bar.advanced": "Exibir todas as categorias",
  "notifications.column_settings.filter_bar.category": "Barra de filtros rápidos",
  "notifications.column_settings.follow": "Seguidores:",
  "notifications.column_settings.follow_request": "Seguidores pendentes:",
  "notifications.column_settings.group": "Agrupar",
  "notifications.column_settings.mention": "Menções:",
  "notifications.column_settings.poll": "Enquetes:",
  "notifications.column_settings.push": "Notificações push",
  "notifications.column_settings.quote": "Citações:",
  "notifications.column_settings.reblog": "Impulsos:",
  "notifications.column_settings.show": "Mostrar na coluna",
  "notifications.column_settings.sound": "Tocar som",
  "notifications.column_settings.status": "Novas publicações:",
  "notifications.column_settings.unread_notifications.category": "Notificações não lidas",
  "notifications.column_settings.unread_notifications.highlight": "Destacar notificações não lidas",
  "notifications.column_settings.update": "Edições:",
  "notifications.filter.all": "Tudo",
  "notifications.filter.boosts": "Impulsos",
  "notifications.filter.collections": "Coleções",
  "notifications.filter.favourites": "Favoritos",
  "notifications.filter.follows": "Seguidores",
  "notifications.filter.mentions": "Menções",
  "notifications.filter.polls": "Enquetes",
  "notifications.filter.statuses": "Atualizações de pessoas que você segue",
  "notifications.grant_permission": "Permita notificações.",
  "notifications.group": "{count} notificações",
  "notifications.mark_as_read": "Marcar como lidas",
  "notifications.permission_denied": "Navegador não tem permissão para ativar notificações no computador.",
  "notifications.permission_denied_alert": "Verifique a permissão do navegador para ativar notificações no computador.",
  "notifications.permission_required": "Ativar notificações no computador exige permissão do navegador.",
  "notifications.policy.accept": "Aceitar",
  "notifications.policy.accept_hint": "Exibir nas notificações",
  "notifications.policy.drop": "Ignorar",
  "notifications.policy.drop_hint": "Enviar para o vácuo, para nunca mais ser visto",
  "notifications.policy.filter": "Filtrar",
  "notifications.policy.filter_bots_hint": "Contas marcadas como automáticas",
  "notifications.policy.filter_bots_title": "Robôs",
  "notifications.policy.filter_hint": "Enviar para a caixa de notificações filtradas",
  "notifications.policy.filter_limited_accounts_hint": "Limitado pelos moderadores do servidor",
  "notifications.policy.filter_limited_accounts_title": "Contas moderadas",
  "notifications.policy.filter_new_accounts.hint": "Created within the past {days, plural, one {one day} other {# days}}",
  "notifications.policy.filter_new_accounts_title": "Novas contas",
  "notifications.policy.filter_not_followers_hint": "Including people who have been following you fewer than {days, plural, one {one day} other {# days}}",
  "notifications.policy.filter_not_followers_title": "Pessoas que não estão te seguindo",
  "notifications.policy.filter_not_following_hint": "Até que você os aprove manualmente",
  "notifications.policy.filter_not_following_title": "Pessoas que você não segue",
  "notifications.policy.filter_private_mentions_hint": "Filtrado, a menos que respondido em sua própria menção ou se você segue o remetente",
  "notifications.policy.filter_private_mentions_title": "Menções privadas não solicitadas",
  "notifications.policy.title": "Gerenciar notificações de…",
  "notifications_permission_banner.enable": "Ativar notificações no computador",
  "notifications_permission_banner.how_to_control": "Para receber notificações quando o Mastodon não estiver aberto, ative as notificações no computador. Você pode controlar precisamente quais tipos de interações geram notificações no computador através do botão {icon}.",
  "notifications_permission_banner.title": "Nunca perca nada",
  "onboarding.follows.back": "Voltar",
  "onboarding.follows.empty": "Infelizmente, não é possível mostrar resultados agora. Você pode tentar usar a busca ou navegar na página de exploração para encontrar pessoas para seguir, ou tentar novamente mais tarde.",
  "onboarding.follows.next": "Próximo: Configure seu perfil",
  "onboarding.follows.search": "Buscar",
  "onboarding.follows.title": "Comece seguindo pessoas",
  "onboarding.profile.discoverable": "Tornar meu perfil descobrível",
  "onboarding.profile.discoverable_hint": "Quando você aceita a capacidade de descoberta no Mastodon, suas postagens podem aparecer nos resultados de busca e nas tendências, e seu perfil pode ser sugerido a pessoas com interesses similares aos seus.",
  "onboarding.profile.display_name": "Nome de exibição",
  "onboarding.profile.display_name_hint": "Seu nome completo ou apelido…",
  "onboarding.profile.finish": "Finalizar",
  "onboarding.profile.note": "Biografia",
  "onboarding.profile.note_hint": "Você pode @mencionar outras pessoas ou usar #hashtags…",
  "onboarding.profile.title": "Configuração do perfil",
  "onboarding.profile.upload_avatar": "Enviar imagem de perfil",
  "onboarding.profile.upload_header": "Carregar cabeçalho do perfil",
  "password_confirmation.exceeds_maxlength": "A confirmação da senha excede o tamanho máximo de senha",
  "password_confirmation.mismatching": "A confirmação de senha não corresponde",
  "picture_in_picture.restore": "Por de volta",
  "poll.closed": "Terminou",
  "poll.refresh": "Atualizar",
  "poll.reveal": "Ver resultados",
  "poll.total_people": "{count, plural, one {# pessoa} other {# pessoas}}",
  "poll.total_votes": "{count, plural, one {# voto} other {# votos}}",
  "poll.vote": "Votar",
  "poll.voted": "Você votou nesta opção",
  "poll.votes": "{votes, plural, one {# voto} other {# votos}}",
  "poll_button.add_poll": "Adicionar enquete",
  "poll_button.remove_poll": "Remover enquete",
  "privacy.change": "Alterar privacidade da publicação",
  "privacy.direct.long": "Todos mencionados na publicação",
  "privacy.direct.short": "Menção privada",
  "privacy.private.long": "Apenas seus seguidores",
  "privacy.private.short": "Seguidores",
  "privacy.public.long": "Qualquer um dentro ou fora do Mastodon",
  "privacy.public.short": "Público",
  "privacy.quote.anyone": "{visibility}, citações permitidas",
  "privacy.quote.disabled": "{visibility} Citações desabilitadas",
  "privacy.quote.limited": "{visibility} Citações limitadas",
  "privacy.unlisted.additional": "Isso se comporta exatamente como público, exceto que a publicação não aparecerá nos _feeds ao vivo_ ou nas _hashtags_, explorar, ou barra de busca, mesmo que você seja escolhido em toda a conta.",
  "privacy.unlisted.long": "Oculto para os resultados de busca do Mastodon, tendências e linhas do tempo públicas",
  "privacy.unlisted.short": "Público silencioso",
  "privacy_policy.last_updated": "Atualizado {date}",
  "privacy_policy.title": "Política de privacidade",
  "quote_error.edit": "Citações não podem ser adicionadas durante a edição de uma publicação.",
  "quote_error.poll": "Citações não permitidas com enquetes.",
  "quote_error.private_mentions": "Citações não são permitidas com menções diretas.",
  "quote_error.quote": "Somente é permitida uma citação por vez.",
  "quote_error.unauthorized": "Você não tem autorização para citar essa publicação.",
  "quote_error.upload": "Citações não são permitidas com mídias anexadas.",
  "recommended": "Recomendado",
  "refresh": "Atualizar",
  "regeneration_indicator.please_stand_by": "Aguarde um momento.",
  "regeneration_indicator.preparing_your_home_feed": "Preparando seu feed inicial…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# dia} other {# dias}} atrás",
  "relative_time.full.hours": "{number, plural, one {# hora} other {# horas}} atrás",
  "relative_time.full.just_now": "agora mesmo",
  "relative_time.full.minutes": "{number, plural, one {# minuto} other {# minutos}} atrás",
  "relative_time.full.seconds": "{number, plural, one {# segundo} other {# segundos}} atrás",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "agora",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "hoje",
  "remove_quote_hint.button_label": "Entendi",
  "remove_quote_hint.message": "Você pode fazê-lo no menu de opções {icon}.",
  "remove_quote_hint.title": "Deseja remover sua citação publicada?",
  "reply_indicator.attachments": "{count, plural, one {# attachment} other {# attachments}}",
  "reply_indicator.cancel": "Cancelar",
  "reply_indicator.poll": "Enquete",
  "report.block": "Bloquear",
  "report.block_explanation": "Você não verá suas publicações. Ele não poderá ver suas publicações ou segui-lo, e será capaz de perceber que está bloqueado.",
  "report.categories.legal": "Jurídico",
  "report.categories.other": "Outro",
  "report.categories.spam": "Spam",
  "report.categories.violation": "O conteúdo viola uma ou mais regras do servidor",
  "report.category.subtitle": "Escolha a alternativa de melhor correspondência",
  "report.category.title_account": "Conte-nos o que há com este perfil",
  "report.category.title_collection": "Conte-nos o que há com esta coleção",
  "report.category.title_status": "Conte-nos o que há com esta publicação",
  "report.close": "Concluir",
  "report.comment.title": "Há algo mais que você acredita que devemos saber?",
  "report.forward": "Encaminhar para {target}",
  "report.forward_hint": "A conta está em outra instância. Enviar uma cópia anônima da denúncia para lá?",
  "report.mute": "Silenciar",
  "report.mute_explanation": "Você não verá suas publicações. Ele ainda pode seguir você e ver suas publicações, e não saberá que está silenciado.",
  "report.next": "Próximo",
  "report.placeholder": "Comentários adicionais aqui",
  "report.reasons.dislike": "Eu não gosto disso",
  "report.reasons.dislike_description": "Não é algo que você quer ver",
  "report.reasons.legal": "É ilegal",
  "report.reasons.legal_description": "Você acredita que isso viola a lei do seu país ou do seu servidor",
  "report.reasons.other": "É outra coisa",
  "report.reasons.other_description": "O problema não se encaixa em outras categorias",
  "report.reasons.spam": "É spam",
  "report.reasons.spam_description": "Links maliciosos, envolvimento falso ou respostas repetitivas",
  "report.reasons.violation": "Viola as regras do servidor",
  "report.reasons.violation_description": "Você está ciente de que isso quebra regras específicas",
  "report.rules.subtitle": "Selecione tudo que se aplica",
  "report.rules.title": "Quais regras estão sendo violadas?",
  "report.statuses.subtitle": "Selecione tudo que se aplica",
  "report.statuses.title": "Existem postagens que respaldam esse relatório?",
  "report.submission_error": "A denúncia não pôde ser enviada",
  "report.submission_error_details": "Verifique sua conexão e tente novamente mais tarde",
  "report.submit": "Enviar",
  "report.target": "Denunciando {target}",
  "report.thanks.take_action": "Aqui estão suas opções para controlar o que você vê no Mastodon:",
  "report.thanks.take_action_actionable": "Enquanto revisamos isso, você pode tomar uma atitude contra @{name}:",
  "report.thanks.title": "Não quer ver isto?",
  "report.thanks.title_actionable": "Obrigado por denunciar, nós vamos analisar.",
  "report.unfollow": "Deixar de seguir @{name}",
  "report.unfollow_explanation": "Você está seguindo esta conta. Para não ver as publicações dela em sua página inicial, deixe de segui-la.",
  "report_notification.attached_statuses": "{count, plural, one {{count} publicação anexada} other {{count} publicações anexadas}}",
  "report_notification.categories.legal": "Legal",
  "report_notification.categories.legal_sentence": "conteúdo ilegal",
  "report_notification.categories.other": "Outro",
  "report_notification.categories.other_sentence": "outro",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Violação de regra",
  "report_notification.categories.violation_sentence": "violação de regra",
  "report_notification.open": "Abrir denúncia",
  "search.clear": "Limpar busca",
  "search.no_recent_searches": "Nenhuma busca recente",
  "search.placeholder": "Busca",
  "search.quick_action.account_search": "Perfis correspondentes a {x}",
  "search.quick_action.go_to_account": "Ir para a página do perfil {x}",
  "search.quick_action.go_to_hashtag": "Ir para a hashtag {x}",
  "search.quick_action.open_url": "Abrir link no Mastodon",
  "search.quick_action.status_search": "Publicações correspondentes a {x}",
  "search.search_or_paste": "Buscar ou colar URL",
  "search_popout.full_text_search_disabled_message": "Não disponível em {domain}.",
  "search_popout.full_text_search_logged_out_message": "Disponível apenas quando conectado.",
  "search_popout.language_code": "Código ISO do idioma",
  "search_popout.options": "Opções de busca",
  "search_popout.quick_actions": "Ações rápidas",
  "search_popout.recent": "Buscas Recentes",
  "search_popout.specific_date": "data específica",
  "search_popout.user": "usuário",
  "search_results.accounts": "Perfis",
  "search_results.all": "Tudo",
  "search_results.collections": "Coleções",
  "search_results.hashtags": "Hashtags",
  "search_results.no_results": "Sem resultados.",
  "search_results.no_search_yet": "Tente buscar por publicações, perfis e hashtags.",
  "search_results.see_all": "Ver tudo",
  "search_results.statuses": "Publicações",
  "search_results.title": "Buscar por \"{q}\"",
  "server_banner.about_active_users": "Pessoas usando este servidor durante os últimos 30 dias (Usuários ativos mensalmente)",
  "server_banner.active_users": "usuários ativos",
  "server_banner.administered_by": "Administrado por:",
  "server_banner.is_one_of_many": "{domain} é um dos muitos servidores Mastodon independentes que você pode usar para participar do fediverso.",
  "server_banner.more_about_this_server": "Saiba mais sobre este servidor",
  "server_banner.server_stats": "Estatísticas do servidor:",
  "sign_in_banner.create_account": "Criar conta",
  "sign_in_banner.follow_anyone": "Siga alguém pelo fediverso e veja tudo em ordem cronológica. Sem algoritmos, anúncios ou clickbait à vista.",
  "sign_in_banner.mastodon_is": "O Mastodon é a melhor maneira de acompanhar o que está acontecendo.",
  "sign_in_banner.sign_in": "Entrar",
  "sign_in_banner.sso_redirect": "Entrar ou Registrar-se",
  "skip_links.hotkey": "<span>Tecla de atalho</span>{hotkey}",
  "skip_links.skip_to_content": "Conteúdo principal",
  "skip_links.skip_to_navigation": "Navegação principal",
  "status.admin_account": "Abrir interface de moderação para @{name}",
  "status.admin_domain": "Abrir interface de moderação para {domain}",
  "status.admin_status": "Abrir esta publicação na interface de moderação",
  "status.all_disabled": "Impulsos e citações estão desabilitados",
  "status.block": "Bloquear @{name}",
  "status.bookmark": "Salvar",
  "status.cancel_reblog_private": "Desfazer impulso",
  "status.cannot_edit": "Você não tem permissão para editar esta publicação",
  "status.cannot_quote": "Você não tem permissão para citar esta publicação",
  "status.cannot_reblog": "Esta publicação não pode ser impulsionada",
  "status.contains_quote": "Contém citação",
  "status.context.loading": "Carregando mais respostas",
  "status.context.loading_error": "Não foi possível carregar novas respostas",
  "status.context.loading_success": "Novas respostas carregadas",
  "status.context.more_replies_found": "Mais respostas encontradas",
  "status.context.retry": "Tentar novamente",
  "status.context.show": "Mostrar",
  "status.continued_thread": "Continuação da conversa",
  "status.copy": "Copiar link",
  "status.delete": "Excluir",
  "status.delete.success": "Publicação deletada",
  "status.detailed_status": "Visão detalhada da conversa",
  "status.direct": "Mencione em privado @{name}",
  "status.direct_indicator": "Menção privada",
  "status.edit": "Editar",
  "status.edited": "Última edição em {date}",
  "status.edited_x_times": "Editado {count, plural, one {{count} hora} other {{count} vezes}}",
  "status.embed": "Obter código de incorporação",
  "status.favourite": "Favoritar",
  "status.favourites_count": "{count, plural, one {{counter} favorito} other {{counter} favoritos}}",
  "status.filter": "Filtrar esta publicação",
  "status.history.created": "{name} criou {date}",
  "status.history.edited": "{name} editou {date}",
  "status.load_more": "Ver mais",
  "status.media.open": "Clique para abrir",
  "status.media.show": "Clique para mostrar",
  "status.media_hidden": "Mídia sensível",
  "status.mention": "Mencionar @{name}",
  "status.more": "Mais",
  "status.mute": "Silenciar @{name}",
  "status.mute_conversation": "Silenciar conversa",
  "status.not_quoted": "Você não foi citado nesta publicação",
  "status.open": "Expandir esta publicação",
  "status.pin": "Fixar",
  "status.public_only": "Esta publicação é privada",
  "status.quote": "Citar",
  "status.quote.cancel": "Cancelar citação",
  "status.quote_error.blocked_account_hint.title": "Esta publicação está oculta porque você bloqueou @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Esta publicação está oculta porque você bloqueou {domain}.",
  "status.quote_error.filtered": "Oculto devido a um dos seus filtros",
  "status.quote_error.limited_account_hint.action": "Mostrar mesmo assim",
  "status.quote_error.limited_account_hint.title": "Esta conta foi oculta pelos moderadores do {domain}.",
  "status.quote_error.muted_account_hint.title": "Esta publicação está oculta porque você silenciou @{name}.",
  "status.quote_error.not_available": "Publicação indisponível",
  "status.quote_error.pending_approval": "Publicação pendente",
  "status.quote_error.pending_approval_popout.body": "No Mastodon, você pode controlar se alguém pode citar você. Esta publicação está pendente enquanto estamos recebendo a aprovação do autor original.",
  "status.quote_error.revoked": "Publicação removida pelo autor",
  "status.quote_followers_only": "Apenas seguidores podem citar sua publicação",
  "status.quote_manual_review": "Autor irá revisar manualmente",
  "status.quote_noun": "Citação",
  "status.quote_policy_change": "Mude quem pode citar",
  "status.quote_post_author": "Publicação citada por @{name}",
  "status.quote_private": "Publicações privadas não podem ser citadas",
  "status.quotes.empty": "Ninguém citou essa publicação até agora. Quando alguém citar aparecerá aqui.",
  "status.quotes.local_other_disclaimer": "Citações rejeitadas pelo autor não serão exibidas.",
  "status.quotes.remote_other_disclaimer": "Apenas citações do {domain} têm a garantia de serem exibidas aqui. Citações rejeitadas pelo autor não serão exibidas.",
  "status.quotes_count": "{count, plural, one {{counter} citação} other {{counter} citações}}",
  "status.read_more": "Ler mais",
  "status.reblog": "Impulsionar",
  "status.reblog_or_quote": "Impulsionar ou citar",
  "status.reblog_private": "Compartilhar novamente com seus seguidores",
  "status.reblogged_by": "{name} impulsionou",
  "status.reblogs.empty": "Ninguém impulsionou esta publicação ainda. Quando alguém o fizer, o usuário aparecerá aqui.",
  "status.reblogs_count": "{count, plural, one {{counter} impulso} other {{counter} impulsos}}",
  "status.redraft": "Excluir e rascunhar",
  "status.remove_bookmark": "Remover do Salvos",
  "status.remove_favourite": "Remover dos favoritos",
  "status.remove_quote": "Remover",
  "status.replied_in_thread": "Respondido na conversa",
  "status.replied_to": "Em resposta a {name}",
  "status.reply": "Responder",
  "status.replyAll": "Responder a conversa",
  "status.report": "Denunciar @{name}",
  "status.request_quote": "Solicitar citação",
  "status.revoke_quote": "Remover minha publicação de@{name} publicação",
  "status.sensitive_warning": "Mídia sensível",
  "status.share": "Compartilhar",
  "status.show_less_all": "Mostrar menos em tudo",
  "status.show_more_all": "Mostrar mais em tudo",
  "status.show_original": "Mostrar original",
  "status.title.with_attachments": "{user} postou {attachmentCount, plural, one {um anexo} other {{attachmentCount} attachments}}",
  "status.translate": "Traduzir",
  "status.translated_from_with": "Traduzido do {lang} usando {provider}",
  "status.uncached_media_warning": "Pré-visualização não disponível",
  "status.unmute_conversation": "Dessilenciar conversa",
  "status.unpin": "Desafixar",
  "subscribed_languages.lead": "Apenas publicações nos idiomas selecionados aparecerão na sua página inicial e outras linhas do tempo após a mudança. Selecione nenhum para receber publicações em todos os idiomas.",
  "subscribed_languages.save": "Salvar alterações",
  "subscribed_languages.target": "Alterar idiomas inscritos para {target}",
  "tabs_bar.home": "Página inicial",
  "tabs_bar.menu": "Menu",
  "tabs_bar.notifications": "Notificações",
  "tabs_bar.publish": "Nova publicação",
  "tabs_bar.quick_links": "Links rápidos",
  "tabs_bar.search": "Buscar",
  "tag.remove": "Remover",
  "terms_of_service.effective_as_of": "Em vigor a partir de {date}",
  "terms_of_service.title": "Termos de serviço",
  "terms_of_service.upcoming_changes_on": "Próximas mudanças em {date}",
  "time_remaining.days": "{number, plural, one {# dia restante} other {# dias restantes}}",
  "time_remaining.hours": "{number, plural, one {# hora restante} other {# horas restantes}}",
  "time_remaining.minutes": "{number, plural, one {# minuto restante} other {# minutos restantes}}",
  "time_remaining.moments": "Momentos restantes",
  "time_remaining.seconds": "{number, plural, one {# segundo restante} other {# segundos restantes}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} pessoa} other {{counter} pessoas}} no(s) último(s) {days, plural, one {dia} other {{days} dias}}",
  "trends.trending_now": "Em alta agora",
  "ui.beforeunload": "Seu rascunho será perdido se sair do Mastodon.",
  "units.short.billion": "{count} bi",
  "units.short.million": "{count} mi",
  "units.short.thousand": "{count} mil",
  "upload_area.title": "Arraste e solte para enviar",
  "upload_button.label": "Adicionar mídia",
  "upload_error.limit": "Limite de anexação alcançado.",
  "upload_error.poll": "Mídias não podem ser anexadas em publicações com enquetes.",
  "upload_error.quote": "Mídias não podem ser anexadas com enquetes.",
  "upload_form.drag_and_drop.instructions": "Para pegar um anexo de mídia, pressione espaço ou enter. Enquanto arrastar, use as setas do teclado para mover o anexo de mídia em qualquer direção. Pressione espaço ou insira novamente para soltar o anexo de mídia em sua nova posição, ou pressione escape para cancelar.",
  "upload_form.drag_and_drop.on_drag_cancel": "O arrastamento foi cancelado. O anexo da mídia {item} foi descartado.",
  "upload_form.drag_and_drop.on_drag_end": "O anexo {item} foi removido.",
  "upload_form.drag_and_drop.on_drag_over": "O anexo de mídia {item} foi movido.",
  "upload_form.drag_and_drop.on_drag_start": "Foi coletado o anexo de mídia {item}.",
  "upload_form.edit": "Editar",
  "upload_progress.label": "Enviando...",
  "upload_progress.processing": "Processando…",
  "username.taken": "Esse nome de usuário já está sendo usado. Por favor, tente outro.",
  "video.close": "Fechar vídeo",
  "video.download": "Baixar",
  "video.exit_fullscreen": "Sair da tela cheia",
  "video.expand": "Abrir vídeo",
  "video.fullscreen": "Tela cheia",
  "video.hide": "Ocultar mídia",
  "video.mute": "Silenciar",
  "video.pause": "Pausar",
  "video.play": "Executar",
  "video.skip_backward": "Retroceder",
  "video.skip_forward": "Avançar",
  "video.unmute": "Ativar som",
  "video.volume_down": "Diminuir o volume",
  "video.volume_up": "Aumentar o volume",
  "visibility_modal.button_title": "Selecionar Visibilidade",
  "visibility_modal.direct_quote_warning.text": "Se salvar as configurações atuais, a cotação incorporada será convertida em um link.",
  "visibility_modal.direct_quote_warning.title": "Citações não podem ser incorporadas em menções privadas",
  "visibility_modal.header": "Visibilidade e interação",
  "visibility_modal.helper.direct_quoting": "Menções privadas escritas no Mastodon.",
  "visibility_modal.helper.privacy_editing": "A visibilidade não pode ser alterada após uma publicação ser publicada.",
  "visibility_modal.helper.privacy_private_self_quote": "As auto-citações de publicações privadas não podem ser públicas.",
  "visibility_modal.helper.private_quoting": "Posts somente para seguidores feitos no Mastodon não podem ser citados por outros.",
  "visibility_modal.helper.unlisted_quoting": "Quando as pessoas citam você, sua publicação também será ocultada das linhas de tempo de tendência.",
  "visibility_modal.instructions": "Controle quem pode interagir com este post. Você também pode aplicar as configurações para todos os posts futuros navegando para <link>Preferências > Padrões de publicação</link>.",
  "visibility_modal.privacy_label": "Visibilidade",
  "visibility_modal.quote_followers": "Apenas seguidores",
  "visibility_modal.quote_label": "Quem pode citar",
  "visibility_modal.quote_nobody": "Apenas eu",
  "visibility_modal.quote_public": "Qualquer um",
  "visibility_modal.save": "Salvar"
}
